import React from "react";
import CardIcon from "../../../../assets/profile/icons/card.svg";
import UserIcon from "../../../../assets/profile/icons/user.svg";
import DynamicsIcon from "../../../../assets/profile/icons/dynamics.svg";
import { Box, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/mousewheel";
import "swiper/css/pagination";
import { AffiliatesStatisticsBlock } from "../elements/AffiliatesStatisticsBlock";
import { AffiliatesApiData } from "../interfaces";
import { calculateTotalEarned } from "../utils";
import { createStatisticsElements } from "../contants";

export const AffiliatesMainStatisticsContainer = ({
  sidebarWidth,
  data,
}: {
  sidebarWidth: number;
  data: AffiliatesApiData[];
}) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const is970px = useMediaQuery("(max-width: 970px)");

  const totalNumberOfLeads = data?.length;
  const totalEarning = calculateTotalEarned(data);
  const activeLeadsCount =
    data?.filter((lead) => lead.leadStatus === "active").length || 0;

  const statisticsElement = createStatisticsElements(
    totalEarning,
    totalNumberOfLeads,
    activeLeadsCount,
    is970px
  );
  return (
    <Box
      sx={{
        width: `calc(100vw - ${is970px ? "20px" : `${sidebarWidth + 100}px`})`,
        flex: "1",
        boxSizing: "border-box",
        mt: "20px",
        direction: isRTL ? "rtl" : "ltr",
        pl: isRTL ? "0" : is970px ? "20px" : 0,
        pr: isRTL ? (is970px ? "20px" : 0) : "0",
      }}
    >
      <Swiper
        key={isRTL ? "rtl" : "ltr"}
        modules={[Mousewheel]}
        slidesPerView={"auto"}
        spaceBetween={20}
        mousewheel={{ forceToAxis: true }}
        className="profile-affiliates-main-statistics-swiper"
      >
        {statisticsElement.map((element, index) => (
          <SwiperSlide key={index}>
            <AffiliatesStatisticsBlock element={element} key={index} />
          </SwiperSlide>
        ))}
        <div className="swiper-pagination"></div>
      </Swiper>
    </Box>
  );
};
